import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-media-service',
  templateUrl: './media-service.component.html',
  styleUrls: ['./media-service.component.scss']
})
export class MediaServiceComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
